// extracted by mini-css-extract-plugin
module.exports = {"brandsFilter":"styles_brandsFilter__D9v7v","filter":"styles_filter___QPBx","pagination":"styles_pagination__PO67i"};